import React, { useState } from 'react'
import CustomModal from '../../../components/CustomModal'
import SlotRules from './SlotRules'
import { Box } from '@shopify/polaris'

export default function SlotRulesModal({ 
  open, 
  onClose, 
  onSave, 
  initialData = null,
  title = "Slot Rules Configuration",
  widgetId = null,
  widgetType = 'slots',
  section = null
}) {
  const [slotRulesData, setSlotRulesData] = useState(initialData)

  const handleSave = () => {
    if (slotRulesData) {
      onSave(slotRulesData)
    }
    onClose()
  }

  const handleSlotRulesSave = (data) => {
    setSlotRulesData(data)
  }

  return (
    <CustomModal
      show={open}
      setShow={onClose}
      variant="large"
      title={title}
      maxHeight={'90vh'}
      height={'85vh'}
    >
      <SlotRules
        onSave={handleSlotRulesSave}
        onCancel={onClose}
        initialData={initialData}
        widgetId={widgetId}
        widgetType={widgetType}
        section={section}
        isInModal={true}
      />
      <Box padding={'400'}/>
    </CustomModal>
  )
} 